import ReelSpinner from "./ReelSpinner";
import Reel from "./Reel";

class ReelSpinnerData {

    public reel: Reel;
    public spinner: ReelSpinner;
    public shift: number;

    constructor(spinner: ReelSpinner, reel: Reel) {

        this.reel = reel;
        this.shift = 0;
        this.spinner = spinner;

    }

    isForceStopping() {
        return this.forceStopping;
    }

    get forceStopping() {
        return this.spinner.isForceStopping();
    }

}

export default ReelSpinnerData;